import { storage } from 'APP/packages/storage';
import { TChatBackground } from 'APP/store/Appearance/Appearance.types';
import Entities from 'STORE';

export function setChatBackgroundForEntity(
  entityId: string,
  chatBackground: TChatBackground
): void {
  const userId = Entities.usersStore.myId;
  if (!userId) {
    return;
  }
  Entities.appearance.setChatBackgroundForEntity(entityId, chatBackground);
  storage.chatBackgroundsByEntity.set(entityId, chatBackground, userId);
}
